module.exports = __webpack_public_path__ + "img/marker-icon-2x-yellow.681191b2.png";